import React from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  Button,
  Text,
} from '@knockrentals/knock-shared-web';
import { Alert, AlertTitle } from '@material-ui/lab';

const useStyles = makeStyles({
  alertContainer: {
    alignItems: 'flex-start',
    border: '1px solid #FFE29D',
    marginBottom: '30px',
  },
});

const AiNurtureError = ({ getAiNurturePropertyData }) => {
  const classes = useStyles();
  const AI_NURTURE_ERROR_TITLE = 'AI Nurture';
  const AI_NURTURE_ERROR_TEXT = 'An unexpected error occurred while retrieving AI Nurture enabled properties. Please try again later.';

  const handleReload = () => {
    getAiNurturePropertyData();
  };

  return (
    <Alert className={classes.alertContainer} severity="warning" action={
      <Button variant='text' size="small" onClick={handleReload}>
        Retry
      </Button>
    }>
      <AlertTitle><Text variant='subtitle1'>{AI_NURTURE_ERROR_TITLE}</Text></AlertTitle>
      <Text variant='body2'>{AI_NURTURE_ERROR_TEXT}</Text>
    </Alert>
  );
};

AiNurtureError.propTypes = {
  getAiNurturePropertyData: PropTypes.func,
};

export default AiNurtureError;
